// Kept dependency-free so syncService can read it without an import cycle through realtimeServices.
let socketConnectedAt: number | null = null;

// Time the realtime socket last connected; null while disconnected or failing to connect
export const getSocketConnectedAt = () => socketConnectedAt;

export const setSocketConnectedAt = (value: number | null) => {
  socketConnectedAt = value;
};
